/** Куб и дуга траектории. Кнопка траектории объекта в 3D-сцене. */
export function ObjectTrajectoryIcon({ className }: { className?: string }) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="none"
      width="24"
      height="24"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7.2 1.8 12.4 4.7v5.4L7.2 13 2 10.1V4.7Z" />
      <path d="M2 4.7 7.2 7.6 12.4 4.7" />
      <path d="M7.2 7.6V13" />
      <path d="M20.2 7.95C20.2 16.2 13.2 20.5 7.15 20.5" />
      <circle cx="20.2" cy="6.4" r="1.55" />
      <circle cx="5.6" cy="20.5" r="1.55" />
    </svg>
  )
}
